/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Item_3_BodyInputs */

const en_wb_management_item_3_body = /** @type {(inputs: Wb_Management_Item_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the August report is prepared, with a mobile form check suggested.`)
};

const lv_wb_management_item_3_body = /** @type {(inputs: Wb_Management_Item_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`augusta atskaite ir sagatavota, ieteikts pārbaudīt formu mobilajā ierīcē.`)
};

/**
* | output |
* | --- |
* | "the August report is prepared, with a mobile form check suggested." |
*
* @param {Wb_Management_Item_3_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_item_3_body = /** @type {((inputs?: Wb_Management_Item_3_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Item_3_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_item_3_body(inputs)
	return en_wb_management_item_3_body(inputs)
});